import { render, staticRenderFns } from "./ServiceTypeList.vue?vue&type=template&id=6c9b4c9e&scoped=true"
import script from "./ServiceTypeList.vue?vue&type=script&lang=js"
export * from "./ServiceTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9b4c9e",
  null
  
)

export default component.exports